import React, { Component } from 'react';
import './AirPagination.css';
import AirButton from '../AirButton';
import { ArrowLeftIcon, ArrowRightIcon } from '../../icons';
import { inject, observer } from 'mobx-react';

@inject('translationsStore')
@observer
export default class AirPagination extends Component {
  render() {
    const { total, pageSize, translationsStore, currentPage, hideOnSinglePage, itemName } = this.props;
    const lastPage = Math.ceil(total / pageSize);

    return (
      <div className={`AirPagination lastPage-${lastPage} ${hideOnSinglePage ? 'hideOnSinglePage' : ''} `}>
        <div className="totals">
          <div>{pageSize * (currentPage - 1) + 1} </div>
          <div className="dash">-</div>
          <div>{Math.min(pageSize * (currentPage - 1) + pageSize, total)} </div>
          <div>&nbsp;{translationsStore.translate('of')}&nbsp;</div>
          <div>{itemName ? `${total} ${itemName}` : total}</div>
        </div>
        <div className="arrows">
          <div className="arrow left">
            <AirButton className={`AirListPaginationButton ${currentPage === 1 ? 'disabled' : ''}`} onClick={this.props.prev} icon={<ArrowLeftIcon />} />
          </div>
          <div className="arrow right">
            <AirButton className={`AirListPaginationButton ${currentPage === lastPage ? 'disabled' : ''}`} onClick={this.props.next} icon={<ArrowRightIcon />} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirPagination/AirPagination.js